import breadcrumbLabels from "@data/config/breadcrumb-labels.json";

const BASE = "https://dbi-analytics.de";

type ListItem = {
  "@type": "ListItem";
  position: number;
  name: string;
  item: string;
};

function humanizeSlug(slug: string): string {
  return slug
    .split("-")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function buildBreadcrumbJsonLd(
  pathname: string,
): Record<string, unknown> | null {
  const raw = pathname.split("?")[0] || "/";
  const trimmed = raw.replace(/\/$/, "") || "/";
  if (trimmed === "") {
    return null;
  }

  const itemListElement: ListItem[] = [
    {
      "@type": "ListItem",
      position: 1,
      name: "Startseite",
      item: `${BASE}/`,
    },
  ];

  if (trimmed === "/") {
    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement,
    };
  }

  const segments = trimmed.split("/").filter(Boolean);
  if (segments.length === 0) {
    return null;
  }

  let cumulative = "";
  let position = 2;

  for (let i = 0; i < segments.length; i++) {
    cumulative += `/${segments[i]}`;
    const seg = segments[i];
    if (!seg) {
      throw new Error("breadcrumbJsonLd: empty path segment");
    }

    const itemUrl = `${BASE}${cumulative}`;
    const atLast = i === segments.length - 1;
    const fullPathKey =
      cumulative as keyof typeof breadcrumbLabels.fullPathNames;
    const fullPathLabel = breadcrumbLabels.fullPathNames[fullPathKey];

    const slugLabel =
      breadcrumbLabels.slugLabels[seg as keyof typeof breadcrumbLabels.slugLabels];
    const segmentLabel =
      breadcrumbLabels.segmentLabels[
        seg as keyof typeof breadcrumbLabels.segmentLabels
      ];

    let name: string;
    if (atLast && fullPathLabel !== undefined) {
      name = fullPathLabel;
    } else if (slugLabel !== undefined) {
      name = slugLabel;
    } else if (segmentLabel !== undefined) {
      name = segmentLabel;
    } else {
      name = humanizeSlug(seg);
    }

    itemListElement.push({
      "@type": "ListItem",
      position,
      name,
      item: itemUrl,
    });
    position += 1;
  }

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement,
  };
}
